import React from 'react';

import { NumberInput, Paper, Stack, Text, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { FormValues } from '../types';

interface IKiloGLMCheckinsNumberProps {
  form: UseFormReturnType<FormValues, (values: FormValues) => FormValues>;
}

const KiloGLMCheckinsNumber = ({ form }: IKiloGLMCheckinsNumberProps): JSX.Element => {
  const value = form.values.checkinsNumber ?? '';

  const handleChange = (val: number | ''): void => {
    form.setFieldValue('checkinsNumber', val === '' ? null : val);
  };

  return (
    <Paper>
      <Stack justify='center' align='center' sx={{ paddingTop: '20px' }}>
        <>
          <Title order={3} align='center'>
            Check-in Number
          </Title>
          <Text lineClamp={4} size={18}>
            Enter the check-in number that triggers the flow
          </Text>
          <NumberInput
            label='Check-in Number'
            placeholder='Enter number'
            withAsterisk
            value={value}
            onChange={handleChange}
            min={1}
            step={1}
            precision={0}
            style={{ width: '100%' }}
            size='md'
            parser={val => val?.replace(/[^0-9]/g, '')}
            formatter={val => (val ? String(Math.floor(Number(val))) : '')}
          />
        </>
      </Stack>
    </Paper>
  );
};

export default KiloGLMCheckinsNumber;
